export default __webpack_public_path__ + "static/UniversalJungle-515-53aeed452d812753b9dc8e88628ee12b.woff2";